import { StyleSheet } from 'react-native'
import type { StyleProp, ViewStyle } from 'react-native'
import styled from 'styled-components/native'
import type { DefaultTheme } from 'styled-components/native'

interface ResponsiveVideoProps {
  $stacked: boolean
}

export const Container = styled.View`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.videoBg};
`

export const VideosContainer = styled.View<ResponsiveVideoProps>`
  height: 100%;
  width: 100%;
  position: relative;
  display: grid;
  grid-template-rows: 0.5fr 0.5fr;
  grid-template-columns: 1fr;

  ${({ $stacked, theme }) =>
    !$stacked &&
    `
      padding: 0 ${theme.metrics.baseMargin}px;
      grid-template-rows: 1fr;
      grid-template-columns: 0.5fr 0.5fr;
      align-items: center;
      align-self: center;
    `}
`

export const VideoContainer = styled.View<ResponsiveVideoProps>`
  position: relative;
  overflow: hidden;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.primary};

  ${({ $stacked, theme }) =>
    !$stacked &&
    `
      aspect-ratio: 16 / 10;
      border-radius: ${theme.metrics.borderRadius.small}px;
      margin: 0 ${theme.metrics.baseMargin / 2}px;
      border: 1px solid ${theme.colors.lightGray};
    `}
`

export const ButtonRow = styled.View`
  position: absolute;
  right: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  bottom: ${({ theme }) => theme.metrics.bottomSpace + theme.metrics.baseMargin / 2}px;
  left: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  z-index: 4;
  flex-direction: row;
  justify-content: center;
  gap: ${({ theme }) => theme.metrics.baseMargin * 4}px;
`

export const pubPacketLossOverlayContainer = (theme: DefaultTheme): StyleProp<ViewStyle> => [
  StyleSheet.absoluteFill,
  {
    zIndex: 1,
    padding: theme.metrics.baseMargin,
    top: 0,
    position: 'absolute',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
]
